import ABI from './abi.json';
import { ChainId } from '../../constants';

export const Config = {
    [ChainId.metisMainnet]: {
        address: '0x326153ad128C97D502f88c8b0Da177C405c19AC0',
        abi: ABI,
    },
    [ChainId.metisTestnet]: {
        // address: '0x4200000000000000000000000000000000000010',
        address: '',
        abi: ABI,
    },
};
